import * as React from 'react';
import * as hash from 'object-hash';
import * as _ from 'lodash'; import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, IReferralConfigResponse, CenterActionCreators, IReferralConfigLookupDataResponse } from '@nkr/store/index';
import { IReferralConfig, IReferralConfigRequest, IBaseResponse, IListItem } from '@nkr/models/index';
import { IValidation } from '../validation';
import ReferralConfigForm from '../referral-config';
import { toast } from 'react-toastify';
import { Alert } from 'react-bootstrap';

interface IOwnProps {
    centerId: number,
    isAdmin: boolean,
    isAdminUser: boolean
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getReferralConfig: (id: number) => Promise<IReferralConfigResponse>,
    saveReferralConfig: (centerId: number, data: IReferralConfigRequest) => Promise<IBaseResponse>,
    getLookupData: (centerId: number) => Promise<IReferralConfigLookupDataResponse>
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface IState {
    centerId: number,
    referralconfig: IReferralConfig,
    hashValue: string,
    hash: string,
    hasDataChanged: boolean,
    validation: IValidation,
    dirty: boolean,
    dataChangedWarning: {
        show: boolean,
        href: string
    },
    lookUpData: {
        statusList: IListItem[],
        followUpList: IListItem[],
        diabetesStatusList: IListItem[],
        customKitsList: IListItem[],
        preWorkupLabConfigList: IListItem[],
        cancerTypeList: IListItem[],
        fvVideoList: IListItem[],
        svVideoList: IListItem[],
        donorConnectGroups: IListItem[]
    }
}

class DashIntakeConfig extends React.Component<TProps, IState> {
    readonly state: IState = {
        centerId: 0,
        referralconfig: null,
        hashValue: '',
        hash: '',
        hasDataChanged: false,
        dataChangedWarning: {
            show: false,
            href: ''
        },
        lookUpData: {
            statusList: [],
            followUpList: [],
            diabetesStatusList: [],
            customKitsList: [],
            preWorkupLabConfigList: [],
            cancerTypeList: [],
            fvVideoList: [],
            svVideoList: [],
            donorConnectGroups: []
        },
        validation: {
            isRegistrationEnabled: true,
            useQuickStart: true,
            useAdpDefaults: true,
            useReducedQuestions: true,
            useCystatinC: true,
            offerDonorConnect: true,
            offerRuleOutTransfer: true,
            isDonorConnectLiverEnabled: true,
            isFamilyVoucherLinkOption: true,
            isStandardVoucherLinkOption: true,
            isDonorConnectNegC: true,
            referDonorToNkr: false,
            askSexualSocialQuestions: true,
            askForId: true,
            doRealTimeEval: true,
            callbackBusinessDays: true,
            dashDonorDaysToExpire: true,
            yearsForFollowUpLabs: true,
            recipientMaxAge: true,
            donorMaxAge: true,
            intakeWorkflowConfig: true,
            dashDonorDaysToExpireText: true,
            dashUsesPwlQuest: true,
            dashUsesPwlAtMiles: true,
            dashUsesFiveStar: true,
            usesPwlForNdd: true,
            usesPwlForAdp: true,
            usesPwlForLongDistanceDonors: true,
            bmiLimit: true,
            bmiRequiredForSurgery: true,
            bmiLimitLiver: true,
            bmiRequiredForSurgeryLiver: true,
            minAgeNdd: true,
            minAgeDd: true,
            mustAcceptBloodTransfusions: true,
            ruleOutOnGestationalDiabetes: true,
            ruleOutOnKidneyDisease: true,
            ruleOutOnHiv: true,
            alwaysRuleOutOnHeartAttack: true,
            requireQuitTobacco: true,
            heartAttackRemissionRequired: true,
            diabetesFailLevel: true,
            plDashPhoneIsDisplayed: true,
            ruleOutOnPregnancy: true,
            ruleOutOnPregnancyWaitTime: true,
            ruleOutOnNursing: true,
            liverRuleOutLiverDisease: true,
            liverRuleOutKidneyDisease: true,
            liverRuleOutHepB: true,
            liverRuleOutHepC: true,
            liverRuleOutDiabetes: true,
            liverDonorMaxAge: true,
            expertSystemAutomated: true,
            expireToQueuePostScreening: true
        },
        dirty: false
    }

    componentDidMount() {
        this.getReferralData();
    }

    handleReferralConfigSave = async () => {
        let validation = await this.validate();

        this.setState({
            validation,
            dirty: true
        }, () => {
            if (this.isValid()) {
                var data = _.cloneDeep(this.state.referralconfig);

                let request: IReferralConfigRequest = {
                    ...(data as unknown as IReferralConfigRequest),
                    centerId: this.state.centerId
                };

                this.props.showLoading('Saving referral config, one moment please...').then(() => {
                    this.props.saveReferralConfig(this.props.centerId, request).then(response => {
                        if (response.data.success) {
                            toast.success('Referral Config saved successfully');
                        }

                        this.props.hideLoading();
                    });
                });
            }
            else {
                toast.error('Please fill out all required fields', { autoClose: 5000 })
            }
        });
    }

    getReferralData = () => {
        this.props.showLoading('Loading referral config, one moment please...').then(() => {
            Promise.all([
                this.props.getReferralConfig(this.props.centerId),
                this.props.getLookupData(this.props.centerId)
            ]).then(([referralConfigResponse, lookUpResponse]) => {
                this.setState({
                    referralconfig: referralConfigResponse.data.results,
                    lookUpData: lookUpResponse.data.results
                }, () => {
                    this.props.hideLoading();
                });
            });
        });
    }

    handleDataChange = (referralData: IReferralConfig) => {
        this.setState({
            referralconfig: referralData
        });

        let newHash = hash(referralData);

        let hasChanged = this.state.hash != newHash;

        this.setState({
            hasDataChanged: hasChanged
        });
    }

    validate = () => {
        let {
            isRegistrationEnabled,
            useQuickStart,
            useAdpDefaults,
            useReducedQuestions,
            useCystatinC,
            offerDonorConnect,
            offerRuleOutTransfer,
            isDonorConnectLiverEnabled,
            isDonorConnectNegC,
            askSexualSocialQuestions,
            askForId,
            doRealTimeEval,
            callbackBusinessDays,
            dashDonorDaysToExpire,
            yearsForFollowUpLabs,
            recipientMaxAge,
            donorMaxAge,
            intakeWorkflowConfig,
            dashDonorDaysToExpireText,
            dashUsesPwlQuest,
            dashUsesPwlAtMiles,
            dashUsesFiveStar,
            usesPwlForNdd,
            usesPwlForAdp,
            usesPwlForLongDistanceDonors,
            bmiLimit,
            bmiRequiredForSurgery,
            bmiLimitLiver,
            bmiRequiredForSurgeryLiver,
            minAgeNdd,
            minAgeDd,
            mustAcceptBloodTransfusions,
            ruleOutOnGestationalDiabetes,
            ruleOutOnKidneyDisease,
            ruleOutOnHiv,
            alwaysRuleOutOnHeartAttack,
            requireQuitTobacco,
            heartAttackRemissionRequired,
            diabetesFailLevel,
            plDashPhoneIsDisplayed,
            ruleOutOnPregnancy,
            ruleOutOnPregnancyWaitTime,
            ruleOutOnNursing,
            liverRuleOutLiverDisease,
            liverRuleOutKidneyDisease,
            liverRuleOutHepB,
            liverRuleOutHepC,
            liverRuleOutDiabetes,
            liverDonorMaxAge,
            expertSystemAutomated,
            followUpAllowPhlebot,
            expireToQueuePostScreening,
            isStandardVoucherLinkOption,
            isFamilyVoucherLinkOption,
            referDonorToNkr
        } = this.state.referralconfig;

        let validation: IValidation = {
            isRegistrationEnabled: isRegistrationEnabled != null,
            useQuickStart: useQuickStart != null,
            useAdpDefaults: useAdpDefaults != null,
            useReducedQuestions: useReducedQuestions != null,
            useCystatinC: useCystatinC != null,
            offerDonorConnect: offerDonorConnect != null,
            offerRuleOutTransfer: offerRuleOutTransfer != null,
            isDonorConnectLiverEnabled: isDonorConnectLiverEnabled != null,
            isDonorConnectNegC: isDonorConnectNegC != null,
            referDonorToNkr: referDonorToNkr !== null,
            askSexualSocialQuestions: askSexualSocialQuestions != null,
            askForId: askForId != null,
            doRealTimeEval: doRealTimeEval != null,
            callbackBusinessDays: callbackBusinessDays != '',
            dashDonorDaysToExpire: dashDonorDaysToExpire != null,
            yearsForFollowUpLabs: yearsForFollowUpLabs != null,
            recipientMaxAge: recipientMaxAge != '',
            donorMaxAge: donorMaxAge != '' && parseInt(donorMaxAge) <= 255 && parseInt(donorMaxAge) > 0,
            intakeWorkflowConfig: intakeWorkflowConfig != null,
            dashDonorDaysToExpireText: dashDonorDaysToExpireText != null,
            dashUsesPwlQuest: dashUsesPwlQuest != null,
            dashUsesPwlAtMiles: dashUsesPwlAtMiles != null,
            dashUsesFiveStar: dashUsesFiveStar != null,
            usesPwlForNdd: usesPwlForNdd != null,
            usesPwlForAdp: usesPwlForAdp != null,
            usesPwlForLongDistanceDonors: usesPwlForLongDistanceDonors != null,
            bmiLimit: bmiLimit != '',
            bmiRequiredForSurgery: bmiRequiredForSurgery != '',
            bmiLimitLiver: bmiLimitLiver != '',
            bmiRequiredForSurgeryLiver: bmiRequiredForSurgeryLiver != '',
            minAgeNdd: minAgeNdd != '' && parseInt(minAgeNdd) <= 255 && parseInt(minAgeNdd) > 0,
            minAgeDd: minAgeDd != '' && parseInt(minAgeDd) <= 255 && parseInt(minAgeDd) > 0,
            mustAcceptBloodTransfusions: mustAcceptBloodTransfusions != null,
            ruleOutOnGestationalDiabetes: ruleOutOnGestationalDiabetes != null,
            ruleOutOnKidneyDisease: ruleOutOnKidneyDisease != null,
            ruleOutOnHiv: ruleOutOnHiv != null,
            alwaysRuleOutOnHeartAttack: alwaysRuleOutOnHeartAttack != null,
            requireQuitTobacco: requireQuitTobacco != null,
            heartAttackRemissionRequired: heartAttackRemissionRequired != null,
            diabetesFailLevel: diabetesFailLevel != null,
            plDashPhoneIsDisplayed: plDashPhoneIsDisplayed != null,
            ruleOutOnPregnancy: ruleOutOnPregnancy != null,
            ruleOutOnPregnancyWaitTime: ruleOutOnPregnancyWaitTime != null,
            ruleOutOnNursing: ruleOutOnNursing != null,
            liverRuleOutLiverDisease: liverRuleOutLiverDisease != null,
            liverRuleOutKidneyDisease: liverRuleOutKidneyDisease != null,
            liverRuleOutHepB: liverRuleOutHepB != null,
            liverRuleOutHepC: liverRuleOutHepC != null,
            liverRuleOutDiabetes: liverRuleOutDiabetes != null,
            liverDonorMaxAge: liverDonorMaxAge != '' && parseInt(liverDonorMaxAge) <= 255 && parseInt(liverDonorMaxAge) > 0,
            expertSystemAutomated: expertSystemAutomated != null,
            expireToQueuePostScreening: expireToQueuePostScreening != null,
            isFamilyVoucherLinkOption: true,
            isStandardVoucherLinkOption: true
        };

        return validation;
    }

    isValid = () => {
        let { validation } = this.state;
        let isAdminUser = this.props.isAdminUser;

        let commonConditions = [
            validation.useQuickStart,
            validation.useReducedQuestions,
            validation.useCystatinC,
            validation.askSexualSocialQuestions,
            validation.askForId,
            validation.doRealTimeEval,
            validation.callbackBusinessDays,
            validation.dashDonorDaysToExpire,
            validation.yearsForFollowUpLabs,
            validation.recipientMaxAge,
            validation.donorMaxAge,
            validation.intakeWorkflowConfig,
            validation.dashDonorDaysToExpireText,
            validation.dashUsesPwlQuest,
            validation.dashUsesPwlAtMiles,
            validation.usesPwlForNdd,
            validation.usesPwlForAdp,
            validation.usesPwlForLongDistanceDonors,
            validation.bmiLimit,
            validation.bmiRequiredForSurgery,
            validation.bmiLimitLiver,
            validation.bmiRequiredForSurgeryLiver,
            validation.minAgeNdd,
            validation.minAgeDd,
            validation.mustAcceptBloodTransfusions,
            validation.ruleOutOnGestationalDiabetes,
            validation.ruleOutOnKidneyDisease,
            validation.ruleOutOnHiv,
            validation.alwaysRuleOutOnHeartAttack,
            validation.requireQuitTobacco,
            validation.heartAttackRemissionRequired,
            validation.diabetesFailLevel,
            validation.plDashPhoneIsDisplayed,
            validation.ruleOutOnPregnancy,
            validation.ruleOutOnPregnancyWaitTime,
            validation.ruleOutOnNursing,
            validation.liverRuleOutLiverDisease,
            validation.liverRuleOutKidneyDisease,
            validation.liverRuleOutHepB,
            validation.liverRuleOutHepC,
            validation.liverRuleOutDiabetes,
            validation.liverDonorMaxAge,
            validation.expertSystemAutomated,
            validation.expireToQueuePostScreening,
        ];

        let isValid = isAdminUser ?
            commonConditions.every(condition => condition) &&
            validation.isRegistrationEnabled &&
            validation.useAdpDefaults &&
            validation.offerDonorConnect &&
            validation.isStandardVoucherLinkOption &&
            validation.offerRuleOutTransfer &&
            validation.isDonorConnectLiverEnabled &&
            validation.isDonorConnectNegC &&
            validation.referDonorToNkr &&
            validation.dashUsesFiveStar
            :
            commonConditions.every(condition => condition);

        return isValid;
    }

    render = () => {
        let isValid = this.isValid();

        return (
            <div>
                {/* <h1 style={{ margin: 0 }}>Referral Configuration Options</h1> */}

                {this.state.dirty && !isValid && (
                    <div className='row'>
                        <div className='col-xs-12 col-lg-12'>
                            <Alert bsStyle='danger'>
                                Please fill out all required fields below. <br /> Please ensure data is valid.
                            </Alert>
                        </div>
                    </div>
                )}

                {this.state.referralconfig != null && (
                    <ReferralConfigForm
                        data={this.state.referralconfig}
                        lookUpData={this.state.lookUpData}
                        isAdmin={this.props.isAdmin}
                        isAdminUser={this.props.isAdminUser}
                        onSave={this.handleReferralConfigSave}
                        onChange={this.handleDataChange}
                        validation={this.state.validation}
                        dirty={this.state.dirty}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        app: appState.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return ({
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getReferralConfig: (id) => {
            return dispatch(CenterActionCreators.getReferralConfig(id));
        },
        saveReferralConfig: (centerId, data) => {
            return dispatch(CenterActionCreators.saveReferralConfig(centerId, data));
        },
        getLookupData: (centerId) => {
            return dispatch(CenterActionCreators.getLookupData(centerId));
        }
    });
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(DashIntakeConfig);

